/** 小さな読み込みスピナー（②）。ローディング/更新中の視覚フィードバックに使う。 */
export function Spinner() {
    return (
        <span className="size-3 shrink-0 animate-spin rounded-full border-2 border-text-muted border-t-transparent" />
    );
}
